import { ExportOption } from '@/components/flow';
import {
  EXPORT_TO_AIRTABLE_FUNCTION_ID,
  EXPORT_TO_API_FUNCTION_ID,
  EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID,
  EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID,
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MANUAL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
} from '@/constants';

export const EXPORTS: ExportOption[] = [
  {
    functionId: EXPORT_TO_MANUAL_FUNCTION_ID,
    config: {},
    name: 'Download manually',
    description: 'Download processed documents in app. (enabled by default)',
    isFakeExport: true,
  },
  {
    functionId: EXPORT_TO_WEBHOOK_FUNCTION_ID,
    config: { httpMethod: 'POST' },
    name: 'Webhook',
    description: 'Export data via HTTP.',
  },
  {
    functionId: EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
    config: {
      createNewWorkbook: true,
      saveOriginalDocument: true,
    },
    name: 'Microsoft Excel',
    description: 'Export to a single or separate workbooks in Excel.',
  },
  {
    functionId: EXPORT_TO_ZAPIER_FUNCTION_ID,
    config: { httpMethod: 'POST' },
    name: 'Zapier',
    description: 'Trigger a Zap using webhooks',
  },
  {
    functionId: EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
    config: {
      httpMethod: 'POST',
      waitForResult: true,
    },
    name: 'Power Automate',
    description: 'Trigger a Power Automate flow using webhooks',
  },
  {
    functionId: EXPORT_TO_MAKE_FUNCTION_ID,
    config: { httpMethod: 'POST' },
    name: 'Make',
    description: 'Trigger a Make scenario using webhooks.',
  },
  {
    functionId: EXPORT_TO_N8N_FUNCTION_ID,
    config: { httpMethod: 'POST' },
    name: 'n8n',
    description: 'Export to a n8n workflow.',
  },
  {
    functionId: EXPORT_TO_AIRTABLE_FUNCTION_ID,
    config: { httpMethod: 'POST' },
    name: 'Airtable',
    description: 'Create a record in Airtable using webhooks.',
    badge: 'Coming soon',
  },
  {
    functionId: EXPORT_TO_API_FUNCTION_ID,
    config: {},
    name: 'API',
    description: 'Use the Cradl API to download files.',
    badge: 'Coming soon',
  },
  {
    functionId: EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID,
    config: {},
    name: 'Google Sheets',
    description: 'Export to a single or separate sheets in Google Sheets.',
    badge: 'Coming soon',
  },
  {
    functionId: EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
    config: {},
    name: 'Microsoft OneDrive',
    description: 'Export documents to a folder in OneDrive.',
    badge: 'Coming soon',
  },
  {
    functionId: EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID,
    config: {},
    name: 'Google Drive',
    description: 'Export documents to a folder in Google Drive.',
    badge: 'Coming soon',
  },
];
